import { Select } from 'antd';

const { Option } = Select;

const CustomSelect = ({ options, placeholder, height, ...props }) => {
  return (
    <Select
      placeholder={placeholder}
      style={{
        width: '100%',
        height: height || 28
      }}
      {...props}
    >
      {options?.map((option) => (
        <Option key={option.value} value={option.value}>
          {option.label}
        </Option>
      ))}
    </Select>
  );
};

export default CustomSelect;